export default function PIFQuestionRenderer({ question, value, onChange, error, fiscalYearLabel }) {
  const { question_id, question_text, response_type, options, figure_unit, is_required, allow_document_upload } = question;

  function handleOptionChange(optionId) {
    onChange(question_id, { response_value: optionId, selected_option_id: optionId });
  }

  function handleFigureChange(numValue) {
    onChange(question_id, { response_value: numValue, selected_option_id: null });
  }

  function handleFileChange(file) {
    onChange(question_id, { file });
  }

  return (
    <div style={{
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius)',
      padding: '16px 18px',
      marginBottom: 16,
      background: '#fff',
    }}>
      <p style={{ fontSize: 15, fontWeight: 500, color: '#1a2744', marginBottom: 12, lineHeight: 1.5 }}>
        {question_text}
        {fiscalYearLabel && (
          <span style={{ fontWeight: 600, color: '#c9952a', marginLeft: 6 }}>— {fiscalYearLabel}</span>
        )}
        {is_required && <span style={{ color: '#dc2626', marginLeft: 4 }}>*</span>}
      </p>

      {(response_type === 'binary' || response_type === 'multiple_choice') && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {options.map(opt => (
            <label key={opt.option_id} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 12px',
              border: `1px solid ${value?.selected_option_id === opt.option_id ? '#c9952a' : '#e2e8f0'}`,
              borderRadius: 6,
              cursor: 'pointer',
              background: value?.selected_option_id === opt.option_id ? '#f5e9d3' : '#fff',
              transition: 'all 0.1s',
            }}>
              <input
                type="radio"
                name={`q_${question_id}`}
                value={opt.option_id}
                checked={value?.selected_option_id === opt.option_id}
                onChange={() => handleOptionChange(opt.option_id)}
                style={{ accentColor: '#c9952a', width: 16, height: 16, flexShrink: 0 }}
              />
              <span style={{ fontSize: 14 }}>{opt.option_text}</span>
            </label>
          ))}
        </div>
      )}

      {response_type === 'figure' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <input
            type="number"
            value={value?.response_value ?? ''}
            onChange={e => handleFigureChange(e.target.value)}
            placeholder="Enter value"
            style={{
              padding: '8px 12px',
              border: `1px solid ${error ? '#dc2626' : '#e2e8f0'}`,
              borderRadius: 6,
              fontSize: 14,
              width: 180,
              outline: 'none',
            }}
          />
          {figure_unit && (
            <span style={{ fontSize: 14, color: '#64748b' }}>{figure_unit}</span>
          )}
        </div>
      )}

      {response_type === 'date' && (
        <input
          type="date"
          value={value?.response_value || ''}
          onChange={e => onChange(question_id, { response_value: e.target.value, selected_option_id: null })}
          max={new Date().toISOString().split('T')[0]}
          style={{
            padding: '8px 12px',
            border: `1px solid ${error ? '#dc2626' : '#e2e8f0'}`,
            borderRadius: 6,
            fontSize: 14,
            outline: 'none',
          }}
        />
      )}

      {response_type === 'text' && (
        <input
          type="text"
          value={value?.response_value || ''}
          onChange={e => onChange(question_id, { response_value: e.target.value, selected_option_id: null })}
          placeholder="Enter your answer"
          style={{
            width: '100%',
            padding: '8px 12px',
            border: `1px solid ${error ? '#dc2626' : '#e2e8f0'}`,
            borderRadius: 6,
            fontSize: 14,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      )}

      {response_type === 'long_text' && (
        <textarea
          value={value?.response_value || ''}
          onChange={e => onChange(question_id, { response_value: e.target.value, selected_option_id: null })}
          placeholder="Enter your answer"
          rows={4}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: `1px solid ${error ? '#dc2626' : '#e2e8f0'}`,
            borderRadius: 6,
            fontSize: 14,
            outline: 'none',
            resize: 'vertical',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
          }}
        />
      )}

      {error && (
        <p style={{ color: '#dc2626', fontSize: 12, marginTop: 6 }}>{error}</p>
      )}

      {allow_document_upload && (
        <div style={{ marginTop: 12 }}>
          <label style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 12px',
            border: '1px dashed #c9952a',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 13,
            color: '#a67d20',
          }}>
            <span>📎</span>
            <span>Attach Document</span>
            <input
              type="file"
              hidden
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              onChange={e => handleFileChange(e.target.files[0])}
            />
          </label>
          {value?.file && (
            <p style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
              ✓ {value.file.name}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
